import React from 'react';
import cls from 'classnames';
import { clsPrefix } from '../const';
import { CnStatisticContentProps } from './types';

/**
 * 指标卡 侧边栏组件
 * @param {*} props
 * @returns
 */
function CnStatisticContent({ children }: CnStatisticContentProps) {
  return <div className={`${clsPrefix}-content`}>{children}</div>;
}

export { CnStatisticContent };
export type { CnStatisticContentProps };
